var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"equities-edit"},[_c('page-header',{attrs:{"header":"Edit IOI"}}),(_vm.data)?_c('edit-form',{ref:"edit",attrs:{"data":_vm.data,"edit":true},on:{"action":_vm.updateIOI}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }